import { ModalConfig } from '@mjcloud/modal-helper';

const config: Partial<ModalConfig> = {
  pageInfo: undefined,
  params: undefined,
};

export default config;
